<template>
  <v-list>
    <v-list-item-group
      :value="value"
      @change="$emit('input', categoryNames[$event])"
      color="primary"
    >
      <v-list-item v-for="category in categoryNames" :key="category" @click="$emit('click-item', category)">
        <v-list-item-content>
          <v-list-item-title>{{ category || "全部" }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  props: ["categories", "value"],
  computed: {
    categoryNames: function () {
      return [null].concat(Object.keys(this.categories));
    },
  },
};
</script>